import { mapActions, mapGetters, mapMutations } from "vuex";

import FontumiCongratsAnimation from "../../assets/fontumi-congrats-animation.gif";

export default {
  name: "Welcome",

  metaInfo: {
    title: "¡Crear botón gratis ahora!"
  },

  components: {
    Overlay: () => import("../../components/Overlay"),
    SourceCode: () => import("../../components/SourceCode")
  },

  data() {
    return {
      FontumiCongratsAnimation,

      countries: [
        {
          text: "Argentina",
          value: "54",
          flag: "ar"
        },
        {
          text: "Colombia",
          value: "57",
          flag: "co"
        },
        {
          text: "Perú",
          value: "51",
          flag: "pe"
        },
        {
          text: "USA",
          value: "1",
          flag: "us"
        }
      ],

      loading: true,

      form: {
        name: "",
        nameRules: [v => !!v || "Nombre requerido"],

        email: "",
        emailRules: [
          v => !!v || "Correo electrónico requerido.",
          v =>
            !!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "Correo electrónico inválido."
        ],

        phone: "",
        phoneRules: [
          v => !!v || "Teléfono requerido.",
          v => /^[0-9]+$/.test(v) || "Número inválido."
        ],

        countryCode: "57",

        valid: false
      },

      step: "form"
    };
  },

  computed: {
    ...mapGetters({
      project: "getProject",
      user: "getUser"
    })
  },

  methods: {
    save() {
      if (this.$refs.form.validate()) {
        setTimeout(() => this.create(), 100);
      }

      return false;
    },

    async create() {
      this.step = "creating";
      try {
        let { email, name, phone, countryCode } = this.form;

        phone = `${phone}`.replace(/ +/g, "");
        await this.createProject({
          name,
          phone: `${countryCode}${phone}`,
          email
        });

        this.setMessage({
          message: "¡Listo! Hemos creado un botón especial para ti.",
          color: "success"
        });

        this.step = "done";
      } catch (e) {
        this.setMessage({
          message: "Ha ocurrido un message. Inténtelo de nuevo.",
          color: "error"
        });

        console.log(e);
        this.step = "form";
      }
    },

    goPanel() {
      this.$router.push({
        name: "home"
      });
    },

    ...mapActions(["createProject"]),
    ...mapMutations(["setMessage"])
  },

  async beforeMount() {
    this.form.email = this.user.email;

    if (this.project) {
      this.step = "done";
      this.setMessage({
        message: "¡Hey! Ya tienes tu botón de llamadas ;)"
      });
    } else {
      this.form.email = this.user.email || "";
      this.form.phone = this.user.phoneNumber
        ? this.user.phoneNumber.slice(1)
        : "";
    }

    this.loading = false;
  }
};
